.mainPaper {
	max-width: 1000px !important;
	margin-bottom: 12px !important;
	align-content: center;
	align-items: center;
	justify-content: center;
}

.topGrid {
	margin-bottom: 10px !important;
	margin-top: 10px !important;
	border: 1px solid var(--title-background-2);
	background-color: var(--extra-light-gray);
	border-radius: 8px 8px 8px 8px;
}

.bottomGrid {
	border: 1px solid var(--title-background-2);
	background-color: var(--extra-light-gray);
	border-radius: 0 0 8px 8px;
}

.title {
	color: var(--dark-gray);
	font-size: 14px !important;
	font-weight: bold !important;
	line-height: 16px !important;
}

.titleDesc {
	color: var(--dark-gray);
	font-size: 16px !important;
	line-height: 20px !important;
}

.tableHeadBackground {
	background-color: var(--title-background-2) !important;
}

.orderNo {
	display: flex !important;

	flex-direction: column;
	align-items: flex-end;
}

.orderTitle {
	font-size: 0.9rem;
}
